(function() {
    $('#removeModal').on('sapphire.remove.invoice.delete', function(event, button){
        $.ajax({
            method: 'delete',
            url: franchiseRoute('invoices/' + button.deleteId)
        }).done(function(){
            $('.modal').trigger('sapphire.reload.tables');
            $('#removeModal').modal('hide');
        });
    });
})()
